import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'shared-page',
      title: `Shared Report Viewer <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'You\'re viewing a shared financial report package. Browse the included reports, adjust date ranges, and export in different formats.',
      attachTo: { element: '[data-tour="shared-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'shared-tabs',
      title: `Report Tabs <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Switch between the reports included in this package — Balance Sheet, Income Statement, General Ledger, and more. Each report has its own view with the pre-configured filters.',
      attachTo: { element: '[data-tour="shared-tabs"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'shared-date-export',
      title: `Date Range & Export <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Adjust the date range to view different periods, or export the report as PDF or Excel. All exports include the current filters and settings.',
      attachTo: { element: '[data-tour="shared-date-range"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'shared-session',
      title: `Session <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'Your session is time-limited for security. If it expires, you\'ll need to re-enter your email to continue viewing. Sessions typically last 2 hours.',
      attachTo: { element: '[data-tour="shared-session"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'sharedReports',
  pathPattern: new RegExp('^/shared-reports/.+/view'),
  getSteps,
  label: 'Shared Report Viewer Tour',
});
